import { updateFieldObject, updateFieldObjectAndDisable } from '../../util/updateFieldObject'
import { mapToSegments } from './mapToSegments'
import { PRODUCTS } from '../../constant/PRODUCTS'

const mapEoiPayloadToFormState = (state, eoiPayload) => {
  state.options.applicantType = updateFieldObjectAndDisable(state, 'options.applicantType', eoiPayload.eoiApplicantType)
  state.options.homeState = updateFieldObjectAndDisable(state, 'options.homeState', eoiPayload.eoiApplication.app.state.abbreviation)
  state.options.situsState = updateFieldObjectAndDisable(state, 'options.situsState', eoiPayload.eoiApplication.employer.address.state.abbreviation)
  state.options.spouseOnly.value = state.options.applicantType.value === 'SP_ONLY' ? 'yes' : 'no'

  const anyProductSelected = PRODUCTS.some(product => eoiPayload.eoiApplication.app[product])
  PRODUCTS.forEach(product => {
    state.options[product] = updateFieldObject(
      state,
      `options.${product}`,
      eoiPayload.eoiApplication.app[product],
      anyProductSelected
    )
  })

  mapToSegments(state, eoiPayload.eoiApplication)
}

export default mapEoiPayloadToFormState